export default function trackBooking({currency, value, reservationId, listingId, listingTitle}) {
  if( typeof window !== 'undefined' ) {
    if( typeof window.fbq !== 'undefined' ) {
      window.fbq('track', 'Purchase', {
        currency,
        value
      }, reservationId);
    }
    if( typeof window.gtag !== 'undefined' ) {
      window.gtag('event', 'purchase', {
        value,
        currency,
        transaction_id: reservationId,
        items: [{
          item_id: listingId,
          item_name: listingTitle,
          price: value,
          quantity: 1
        }]
      });
    }
  }
}


// WEBPACK FOOTER //
// src/helpers/trackBooking.js